import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import { PORTAL_OFFICE_TYPE } from '@/types/types';
import { SxProps, Typography } from '@mui/material';
import { CustomPalettes } from '@/themes';

const ButtonGroupsSxProps: SxProps = {
  width: 362,
  height: 48,
  paddingTop: '6px',
  paddingRight: '8px',
  paddingBottom: '6px',
  paddingLeft: '8px',
  borderRadius: '48px',
  borderWidth: '1px',
  justifyContent: 'space-between',
  backgroundColor: CustomPalettes['Space/pallet/Gray/0'],
};

const BaseButtonSxProps: SxProps = {
  width: 170,
  height: 36,
  gap: '8px',
  borderRadius: '48px !important',
  color: CustomPalettes['Space/pallet/Gray/900'],
  border: 'none',
  '&.Mui-selected': {
    color: CustomPalettes['Space/pallet/Gray/0'],
    backgroundColor: CustomPalettes['Space/pallet/Primary/500-primary'],
    borderColor: CustomPalettes['Space/pallet/Primary/500-primary'],
  },
  '&.Mui-selected:hover': {
    backgroundColor: CustomPalettes['Space/pallet/Primary/500-primary'],
    borderColor: CustomPalettes['Space/pallet/Primary/500-primary'],
    boxShadow: 'none',
  },
};

function CustomToggleButton({
  value,
  label,
  isActive,
}: {
  value: PORTAL_OFFICE_TYPE;
  label: string;
  isActive: boolean;
}) {
  return (
    <ToggleButton value={value} sx={BaseButtonSxProps} disabled={isActive}>
      <Typography
        typography="JP/Body/m/Medium/None"
        sx={{
          fontWeight: 700,
        }}
      >
        {label}
      </Typography>
    </ToggleButton>
  );
}

type Props = {
  activeValue: PORTAL_OFFICE_TYPE;
  onChange: (newValue: PORTAL_OFFICE_TYPE) => void;
};

export function SelectPortalOfficeTypeButton({ activeValue, onChange }: Props) {
  return (
    <ToggleButtonGroup
      value={activeValue}
      exclusive
      onChange={(_, newValue) => {
        onChange(newValue as PORTAL_OFFICE_TYPE);
      }}
      sx={ButtonGroupsSxProps}
    >
      <CustomToggleButton
        label="看護・介護サービス"
        value={PORTAL_OFFICE_TYPE.NURSING_STATION}
        isActive={activeValue === PORTAL_OFFICE_TYPE.NURSING_STATION}
      />
      <CustomToggleButton
        label="医療機関"
        value={PORTAL_OFFICE_TYPE.HOSPITAL}
        isActive={activeValue === PORTAL_OFFICE_TYPE.HOSPITAL}
      />
    </ToggleButtonGroup>
  );
}
